import request from "@/utils/request.js"
// 获取新闻列表
export function get_news_list(data){
  return request({
    	  method:'GET',
    	  url:'/aohua.news/get_news_list',
    	  params:data
    })
}
// 新闻-产品
export function get_product_list(data){
  return request({
    	  method:'GET',
    	  url:'/aohua.news/get_product_list',
    	  params:data
    })
}
